import { render, staticRenderFns } from "./userAccount.vue?vue&type=template&id=d077ba20&"
import script from "./userAccount.vue?vue&type=script&lang=ts&"
export * from "./userAccount.vue?vue&type=script&lang=ts&"
import style0 from "./userAccount.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports